// extracted by mini-css-extract-plugin
export var button = "_9t-4";
export var hasDarkBackground = "_9t-7";
export var hasLightBackground = "_9t-6";
export var iconWrapper = "_9t-0";
export var large = "_9t-2";
export var medium = "_9t-1";
export var small = "_9t-5";
export var xsmall = "_9t-3";